import { Suspense, lazy } from 'react'
import type { ComponentProps } from 'react'
import Loader from '@/components/Loader'

const ImageInput = lazy(() => import('@/components/ui/ImageInput'))

export type LazyImageInputProps = ComponentProps<typeof ImageInput>

export default function LazyImageInput(props: LazyImageInputProps) {
  return (
    <Suspense fallback={<Loader />}>
      <ImageInput {...props} />
    </Suspense>
  )
}
